import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as BucketQL from "queries/bucket";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import { Mutation, Button } from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({
  history,
  match: {
    params,
    params: { bucketId },
  },
}) => {
  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            Removing the bucket <b>{bucketId}</b>? This action will be permanent and
            can't be undone
          </Col>
        </Row>
        <Mutation
          mutation={BucketQL.remove}
          update={BucketQL.update(params)}
          onMutate={({ handler }) => {
            handler({
              variables: {
                bucketId
              },
            });
          }}
          onCompleted={() => {
            history.replace(`/bucket`);
          }}
          onError={(error) => {
            Notify.error(error.toString());
          }}
        >
          {MutationHandler}
        </Mutation>
      </Container>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Row>
      <Col>
        <Button
          onClick={() => {
            mutate();
          }}
        >
          Remove
        </Button>
      </Col>
    </Row>
  );
};
